<template>
  <div class="homeSolucoes w-full">
    <div class="auto-container flex flex-wrap w-full">
      <div class="homepage-title-group">
        <span class="sectionTitle" v-html="solucoes.pagina.titulo"></span>
        <div class="subtitulo" v-html="solucoes.pagina.subtitulo"></div>
      </div>
      <div :class="'solutions-blocks ' + (solucoesDestaque.lenght == 3 ? 'twistLine' : '')" v-if="(solucoesDestaque.length > 0)">
        <div class="flex flex-wrap solutions-blocks-container">
          <div v-for="(forItem, forIndex) in solucoesDestaque" :key="forIndex" :item="forItem" class="solution-block w-full md:w-6 lg:w-4">
            <div class="inner-box">
              <div @click="fc_goRoute('solucao', { id: forItem.id})" class="cursorPointer icon-block">
                <img :src="forItem.logotipo">
              </div>
              <div @click="fc_goRoute('solucao', { id: forItem.id })" class="cursorPointer tituloDestaque" v-html="forItem.tituloDestaque"></div>
              <div class="conteudoDestaque" v-html="forItem.conteudoDestaque"></div>
            </div>
            <div class="btn">
              <div @click="fc_goRoute('solucao', { id: forItem.id })" class="btn-redireciona flex fadeindown animation-duration-1000 mt-5" v-html="fc_getText(null, 'btn_verMais')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      solucoes: {
        pagina: {},
        list: [],
      },
      solucoesDestaque: [],
    };
  },
  props: {
    primeiroDestaque: Number,
    segundoDestaque: Number,
    terceiroDestaque: Number,
  },
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.mt_loadData();
    },
    mt_loadData() {
      if (this.primeiroDestaque != null && this.primeiroDestaque != null) {
        let destaque = this.solucoes.list.find((o) => o.id == this.primeiroDestaque);
        if (destaque != null) { this.solucoesDestaque.push(destaque); }
      }
      if (this.segundoDestaque != null && this.segundoDestaque != null) {
        let destaque = this.solucoes.list.find((o) => o.id == this.segundoDestaque)
        if (destaque != null) { this.solucoesDestaque.push(destaque); }
      }
      if (this.terceiroDestaque != null && this.terceiroDestaque != null) {
        let destaque = this.solucoes.list.find((o) => o.id == this.terceiroDestaque)
        if (destaque != null) { this.solucoesDestaque.push(destaque); }
      }
    }
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'SolucoesPagina/', method: 'GET', success: (response) => { this.solucoes.pagina = response.item; resolve(); }, error: reject }); }));
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'Solucoes/', method: 'GET', success: (response) => { this.solucoes.list = response.list; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  .homeSolucoes {
    position: relative;
    padding:100px 0px 0px;
  }
  .homeSolucoes:before {
    position: absolute;
    left: 17%;
    top: 50px;
    height: 269px;
    width: 366px;
    background-image: url("@/assets/icons/dots-4.png");
    content: "";
  }
  .homeSolucoes .solutions-blocks {
    position: relative;
  }
  .homeSolucoes .solutions-blocks .btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .homeSolucoes .homepage-title-group {
    position: relative;
    margin-bottom: 65px;
  }
  .homeSolucoes .homepage-title-group .titulo {
    margin: 10px 0px 20px 0px;
  }
  .homeSolucoes .solutions-blocks-container {
    margin: 0 -75px;
  }
  .homeSolucoes .solutions-blocks .solution-block{
    position: relative;
    padding: 0 75px;
    margin-bottom: 50px;
    z-index: 1;
  }
  .solutions-blocks .solution-block .inner-box {
    position: relative;
    text-align: center;
    min-height:800px;
  }
  .solutions-blocks .solution-block .icon-block {
    position: relative;
    display: inline-block;
    height: 240px;
    width: 240px;
    margin: 0 auto 40px;
    border-radius: 50%;
    border: 2px dashed #dedede;
  }
  .solution-block .icon-block img {
    position: relative;
    top: 28%;
    display: inline-block;
    height: auto;
    transition: all 300ms ease;
    max-width:80%;
  }
  .solution-block .inner-box:hover .icon-block img {
    transform: scale(1.1);
  }
  .solution-block .tituloDestaque {
    display: block;
    font-size: 20px;
    line-height: 1.2em;
    color: #202020;
    font-weight: bold;
    margin-bottom: 15px;
    min-height: 45px;
    transition: all 300ms ease;
  }
  .solution-block .tituloDestaque:hover {
    color: var(--ibase-color);
  }
  .solution-block .inner-box .conteudoDestaque {
    text-align: justify;
  }
  .solution-block .conteudoDestaque {
    display: block;
    font-size: 14px;
    line-height: 27px;
    color: #888888;
    font-weight: 400;
  }
  .solution-block .btn-redireciona {
    position:absolute;
    bottom:0;
    margin-left:auto;
    margin-right:auto;
    left:0;
    right:0;
    width:180px;
  }
  @media only screen and (max-width: 599px) {
    .homeSolucoes .homepage-title-group .titulo{
      font-size: 24px;
      line-height: 1.3em;
    }
  }
  @media only screen and (max-width: 1140px) {
    .homeSolucoes .solutions-blocks .solution-block {
      padding: 0 15px;
    }
    .homeSolucoes .solutions-blocks-container {
      margin: 0 -15px;
    }
  }
  @media screen and (min-width:1300px) {
    .homeSolucoes .twistLine:before {
      position: absolute;
      left: -97px;
      top: 20px;
      width: 1333px;
      height: 175px;
      background-image: url("@/assets/icons/twist-line.png");
      background-repeat: no-repeat;
      background-position: center;
      content: "";
    }
  }
</style>
